/**
 * Get value of the localstorage item
 * @param {string} key name of the localstorage item
 *
 * @returns {string|null|undefined} item's value or `null` if doesn't exist or `undefined` if `key` isn't provided
 */

/* eslint-disable */
export function getLocalStorageItem(key) {
    if (!key) {
        return;
    }
    return window.localStorage.getItem(key);
}

/**
 * Get all the localstorage items
 * @returns {Array<{key: string, value: string}>|Array<never>} array of objects with `key` and `value` properties or empty array
 */
export function getLocalStorageItems() {
    const items = [];
    for (const [key, value] of Object.entries(window.localStorage)) {
        items.push({ key, value });
    }
    return items;
}
/* eslint-enable */
/**
 * Set localstorage item
 * @param {string} key name of the localstorage item
 * @param {string} value value of the localstorage item
 *
 * @returns {void}
 */
export function setLocalStorageItem(key, value) {
    if (!key || value === undefined) {
        return;
    }
    window.localStorage.setItem(key, value);
}

/**
 * Set localstorage items
 * @param {Array<{key: string, value: string}>} items an array of objects with `key` and `value` properties
 *
 * @returns {void}
 */
export function setLocalStorageItems(items) {
    if (!Array.isArray(items)) {
        return;
    }
    items.forEach(({ key, value }) => {
        this.setLocalStorageItem(key, value);
    });
}

/**
 * Delete localstorage item
 * @param {string} key name of the localstorage item
 *
 * @returns {void}
 */
export function deleteLocalStorageItem(key) {
    if (!key) {
        return;
    }
    window.localStorage.removeItem(key);
}

/**
 * Delete localstorage items
 * @param {Array<string>} keys an array of strings
 *
 * @returns {void}
 */
export function deleteLocalStorageItems(keys) {
    if (!Array.isArray(keys)) {
        return;
    }
    keys.forEach((key) => {
        this.deleteLocalStorageItem(key);
    });
}
